import * as types from '../action_types';

export const setStateUserEnter = (data) => {
  return {
    type: types.SET_STATE_USER_ENTER,
    payload: data,
  };
};
